const formPassword = {
    bindHandler() {
        $('#showPasswordCheck').on('change', (evt) => {
            let $self   = $(evt.currentTarget);
            let $target = $self.closest('form').find('.custom-form__input--password');
            if ($self.prop('checked')) {
                $target.prop('type', 'text');
            } else {
                $target.prop('type', 'password');
            }
        });
    }
};

$(() => {
    formPassword.bindHandler();
});

export default formPassword;
